export default __webpack_public_path__ + "static/media/widget.8aa3c301.jpg";